/* jt-de-apps-standalone */
(function () {
  var loc = (window.Shopify && Shopify.locale || document.documentElement.lang || '').toLowerCase();
  var path = (window.location && window.location.pathname) || '';
  if (!(loc.indexOf('de') === 0 || /^\/de(\/|$)/.test(path))) return;

  var exact = {
    Merk: 'Marke',
    'Selecteer merk': 'Marke wählen',
    Model: 'Modell',
    'Selecteer model': 'Modell wählen',
    Modelcode: 'Modellcode',
    'Selecteer modelcode': 'Modellcode wählen',
    Uitvoering: 'Ausführung',
    'Selecteer uitvoering': 'Ausführung wählen',
    'Zoek onderdelen': 'Teile suchen',
    'Filters wissen': 'Filter löschen',
    'Turbo op toeren... laden': 'Laden...',
    'Turbo op toeren... Laden': 'Laden...',
    Laden: 'Laden',
    Informatie: 'Informationen',
    Zakelijk: 'Geschäftlich',
    'Navigeren naar': 'Navigation',
    Klantenservice: 'Kundenservice',
    Uitstekend: 'Hervorragend',
    'Op basis van': 'Basierend auf',
    reviews: 'Bewertungen',
    Accepteren: 'Akzeptieren',
    Weigeren: 'Ablehnen',
    'Cookie-instellingen': 'Cookie-Einstellungen'
  };

  var phrases = [
    ['Selecteer merk', 'Marke wählen'],
    ['Selecteer model', 'Modell wählen'],
    ['Selecteer modelcode', 'Modellcode wählen'],
    ['Selecteer uitvoering', 'Ausführung wählen'],
    ['Zoek onderdelen', 'Teile suchen'],
    ['Filters wissen', 'Filter löschen'],
    ['Turbo op toeren', 'Laden'],
    ['Op basis van', 'Basierend auf'],
    ['Uitstekend', 'Hervorragend']
  ];

  function fix(raw) {
    if (!raw) return raw;
    var t = String(raw);
    var tr = t.trim();
    if (exact[tr]) return t.replace(tr, exact[tr]);
    for (var i = 0; i < phrases.length; i++) {
      if (t.indexOf(phrases[i][0]) !== -1) t = t.split(phrases[i][0]).join(phrases[i][1]);
    }
    return t;
  }

  function apply(root) {
    var scope = root || document;
    if (!scope) return;
    var tw = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = tw.nextNode())) {
      var next = fix(n.nodeValue);
      if (next !== n.nodeValue) n.nodeValue = next;
    }
    if (scope.querySelectorAll) {
      scope.querySelectorAll('option, label, .easysearch-title, .easysearch-field-title, .footer__title, h2, h3, h4, p, span, button').forEach(function (el) {
        var t = (el.childNodes.length === 1 && el.firstChild && el.firstChild.nodeType === 3)
          ? el.textContent
          : null;
        if (t && exact[t.trim()]) el.textContent = exact[t.trim()];
      });
    }
  }

  function boot() {
    apply(document.body);
    [100, 400, 1000, 2000, 4000, 8000, 15000].forEach(function (ms) {
      setTimeout(function () { apply(document.body); }, ms);
    });
    /* MO removed freeze-v3 */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
/* jt-pl-chrome-inline */
(function(){function isPl(){var l=String(window.Shopify&&Shopify.locale||document.documentElement.lang||"").toLowerCase(),p=window.location&&window.location.pathname||"";return l.indexOf("pl")===0||/^\/pl(\/|$)/.test(p)}if(!isPl())return;var S="Szukaj produktów …",R=/Zoeken\s+naar\s+producten|Search\s+for\s+products/i;function go(){document.querySelectorAll("input,[placeholder]").forEach(function(el){var ph=el.getAttribute("placeholder")||"";if(R.test(ph))el.setAttribute("placeholder",S)});document.querySelectorAll(".custom-hero-banner,.hero,[class*=hero]").forEach(function(w){if(!/TUNING\s*PARTS/i.test(w.textContent||""))return;var tw=document.createTreeWalker(w,NodeFilter.SHOW_TEXT,null),n;while(n=tw.nextNode()){if(n.nodeValue&&/TUNING\s*PARTS/i.test(n.nodeValue))n.nodeValue=n.nodeValue.replace(/TUNING\s*PARTS/gi,"CZĘŚCI TUNINGOWE")}})}go();[200,800,2000,5000].forEach(function(t){setTimeout(go,t)})})();
/* jt-pl-in-de-apps:1785169872721 */

/* jt-freeze-fix-v3 1785685670790 */
